import type React from 'react';
import OrderReturnDetailsView from '@/components/Templates/Returns/OrderReturnDetails/OrderReturnDetailsView';
import type { ProductField } from '@/components/Templates/Returns/ReturnOrderForm/types';

export interface PreviewProps {
	returnOrderInformation: {
		clinicName: string;
		ta_contact: string;
		ta_phone: string;
		ta_streetaddress: string;
		ta_city: string;
		ta_statezip: string;
		products: ProductField[]; // Changed to products array
		ta_hastheproductbeeninyourpossessionupon: boolean;
		ta_hastheproductbeenstoredaccordingtothemanu: boolean;
		ta_hastheproductbeensecurelystoredbyauthoriz: boolean;
		ta_hasanyproductbeenusedoropen: boolean;
		ta_istheproductintheoriginalunmarkedandundam: boolean;
		ta_commentsclarifications: string;
	};
}

const Preview: React.FC<PreviewProps> = ({ returnOrderInformation }) => {
	// Simply pass the data to the shared component
	return <OrderReturnDetailsView data={returnOrderInformation} />;
};

export default Preview;

